<div
  id="page-container"
  class="page-container fade page-sidebar-fixed page-header-fixed show"
  style="height: 100%"
>
  <!-- TOPBAR PARTIAL -->
  <app-topbar-partial
    (notifications)="notifications($event)"
  ></app-topbar-partial>

  <!-- SIDEBAR PARTIAL -->
  <app-sidebar-partial></app-sidebar-partial>

  <!-- CONTENT PARTIAL -->
  <div id="content" class="content" style="height: 100%">
    <router-outlet></router-outlet>
  </div>

  <!-- SCROLL TO TOP PARTIAL -->
  <app-scroll-to-top-partial></app-scroll-to-top-partial>
</div>
